import React from "react";
import OfficeLocationContainer from "./styles/OfficeLocation.style";
import locationNyc from "images/location-nyc.jpg";
import locationChicago from "images/location-chicago.jpg";
import locationGurgaon from "images/location-gurgaon.jpg";
import locationLa from "images/location-la.jpg";
import locationLondon from "images/location-london.jpg";
import locationMke from "images/location-mke.jpg";

const locations = [
  {
    title: "New York",
    address: "485 Lexington Ave.",
    city: "New York, NY 10017"
  },
  {
    title: "Los Angeles",
    address: "5764 W Jefferson Blvd.",
    city: "Los Angeles, CA 90016"
  },
  {
    title: "Chicago",
    address: "111 E Wacker Drive, Suite 2210,",
    city: "Chicago, IL 60601"
  },
  {
    title: "London",
    address: "31-35 Kirby Street",
    city: "London EC1N 8TE"
  },
  {
    title: "Gurgaon",
    address: "7th Floor, DLF Infinity Tower C.",
    city: "DLF Cyber City Gurgaon, Haryana 122010, India"
  },
  {
    title: "Milwaukee",
    address: "1610 N 2nd St.",
    city: "Milwaukee, WI 53212"
  }
];

export function MobileLocationCard({ title, address, city, index }) {
  return (
    <div className={`offices-right-column-row-mobile offices-right-column-row-mobile-${index}`}>
      <div className="offices-right-column-item-mobile">
        <div className="offices-right-column-container-mobile">
          <h5 className="offices-locations-city-title-mobile">{title}</h5>
          <p className="offices-locations-city-description-mobile">{address}</p>
          <p className="offices-locations-city-description-mobile">{city}</p>
        </div>
      </div>
    </div>
  );
}

export function LocationCard({ imageSrc, altText, title, description }) {
  return (
    <div className="offices-locations-column-item">
      <img className="offices-locations-image" src={imageSrc} alt={altText} />
      <div className="offices-locations-text-container">
        <h5 className="offices-locations-city-title">{title}</h5>
        <p className="offices-locations-city-description">{description}</p>
      </div>
    </div>
  );
}

function OfficeLocation() {
  return (
    <OfficeLocationContainer>
      <div className="office-location-column">
        <div className="office-location-intro">
          <h1 className="office-location-title">
            Discover Our Worldwide Offices and Connect with Us Today!
          </h1>
        </div>

        <div className="offices">
          <div className="offices-left-column">
            <div className="offices-rectangle"></div>
            <h5 className="our-offices">Our Offices</h5>
          </div>

          <div className="offices-right-column-desktop">
            <div className="offices-locations-row">
              <div className="offices-locations">
                <div className="offices-locations-column-left">
                  <LocationCard
                    imageSrc={locationNyc}
                    altText="location-new-york-city"
                    title="New York"
                    description="485 Lexington Ave. New York, NY 10017"
                  />
                </div>

                <div className="offices-locations-column-right">
                  <LocationCard
                    imageSrc={locationLa}
                    altText="location-los-angeles"
                    title="Los Angeles"
                    description="5764 W Jefferson Blvd. Los Angeles, CA 90016"
                  />
                </div>
              </div>
            </div>

            <div className="offices-locations-row">
              <div className="offices-locations">
                <div className="offices-locations-column-left">
                  <LocationCard
                    imageSrc={locationChicago}
                    altText="location-chicago"
                    title="Chicago"
                    description="111 E Wacker Drive, Suite 2210, Chicago, IL 60601"
                  />
                </div>

                <div className="offices-locations-column-right">
                  <LocationCard
                    imageSrc={locationLondon}
                    altText="location-london"
                    title="London"
                    description="31-35 Kirby Street London, EC1N 8TE"
                  />
                </div>
              </div>
            </div>

            <div className="offices-locations-row offices-locations-row-gurgaon">
              <div className="offices-locations">
                <div className="offices-locations-column-left">
                  <LocationCard
                    imageSrc={locationGurgaon}
                    altText="location-gurgaon"
                    title="Gurgaon"
                    description="7th Floor, DLF Infinity Tower C. DLF Cyber City, Gurgaon, Haryana 122010, India"
                  />
                </div>

                <div className="offices-locations-column-right">
                  <LocationCard
                    imageSrc={locationMke}
                    altText="location-milwaukee"
                    title="Milwaukee"
                    description="1610 N 2nd St. Milwaukee, WI 53212"
                  />
                </div>
              </div>
            </div>
          </div>

          {locations.map((location, index) => (
            <MobileLocationCard
              key={index}
              title={location.title}
              address={location.address}
              city={location.city}
              index={index}
            />
          ))}
        </div>
      </div>
    </OfficeLocationContainer>
  );
}

export default OfficeLocation;
